import React from 'react';
import { REGISTRATION_AGREEMENT, REGISTRATION_AGREEMENT_VERSION } from '../../constants/registrationAgreement';

export default function RegistrationAgreement({ accepted, onAcceptedChange, disabled = false }) {
  const { independence, recordingCompliance, agentCodeNote, acceptanceLabel } = REGISTRATION_AGREEMENT;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-3">
        <p className="text-[10px] font-black text-[var(--text-secondary)] uppercase tracking-widest">
          Acuerdo de registro
        </p>
        <span className="text-[9px] font-bold text-[var(--text-secondary)] uppercase tracking-wider shrink-0">
          v{REGISTRATION_AGREEMENT_VERSION}
        </span>
      </div>

      <div className="space-y-3">
        <section className="rounded-xl border border-[var(--border-subtle)] bg-[var(--bg-base)] p-4">
          <h2 className="text-[10px] font-black text-[var(--text-main)] uppercase tracking-widest mb-2">
            {independence.title}
          </h2>
          <p className="text-xs text-[var(--text-secondary)] leading-relaxed">{independence.body}</p>
        </section>

        <section className="rounded-xl border border-[var(--border-subtle)] bg-[var(--bg-base)] p-4">
          <h2 className="text-[10px] font-black text-[var(--text-main)] uppercase tracking-widest mb-2">
            {recordingCompliance.title}
          </h2>
          <p className="text-xs text-[var(--text-secondary)] leading-relaxed">{recordingCompliance.body}</p>
        </section>
      </div>

      <div className="rounded-xl border border-brand-gold/30 bg-brand-gold/5 px-4 py-3">
        <p className="text-[10px] text-[var(--text-secondary)] leading-relaxed">
          <span className="font-black text-brand-gold-dark uppercase tracking-widest">Nota: </span>
          {agentCodeNote}
        </p>
      </div>

      <label className="flex items-start gap-3 cursor-pointer group">
        <input
          type="checkbox"
          checked={accepted}
          disabled={disabled}
          onChange={(e) => onAcceptedChange(e.target.checked)}
          className="mt-0.5 h-4 w-4 shrink-0 rounded border-[var(--border-subtle)] text-brand-cyan focus:ring-brand-cyan disabled:opacity-60"
        />
        <span className="text-xs text-[var(--text-main)] leading-relaxed group-disabled:opacity-60">
          {acceptanceLabel}
        </span>
      </label>
    </div>
  );
}
